import { get as _get } from 'lodash';

// Constants
import * as ROUTES from 'constants/routes';
import { MAX_ENTRIES_PER_PAGE } from '../constants';

// Stores
import stores from 'bootstrap/store';
import { history } from 'bootstrap/store/router';

const store = {
  global: {
    prescriptionFills: stores.global.prescriptionFills,
  },
  route: {
    prescriptionFillsMailOrder: stores.route.prescriptionFillsMailOrder.domain,
  },
  history,
};


// List prescription fills considering all dependencies.
export default ({ filterQuery = true, paginate = true, shouldMerge = true } = {}) => {
  const query = {};

  const currentPage = store.route.prescriptionFillsMailOrder.currentPage.prescriptionFills;
  if (paginate) {
    query.offset = MAX_ENTRIES_PER_PAGE * (currentPage - 1);
    query.limit = MAX_ENTRIES_PER_PAGE;
  }

  const filterValue = store.route.prescriptionFillsMailOrder.prescriptionFillsFilterValue;
  if (filterQuery && filterValue) {
    if (store.global.prescriptionFills.mailOrdered.size > MAX_ENTRIES_PER_PAGE - 1) {
      store.global.prescriptionFills.setValue('mailOrdered', {});
    }

    query.filter = {
      '$prescription.patient.firstName$': filterValue,
      '$prescription.patient.lastName$': filterValue,
    };
  }

  const config = { query };

  store.route.prescriptionFillsMailOrder.incrementHttp('listingMailOrderedPrescriptionFills');
  return store.global.prescriptionFills.listMailOrderedForPharmacist(config, {shouldMerge})
  .then((response) => {
    const responseLength = _get(response, 'data.length', 0);
    if (paginate && responseLength > MAX_ENTRIES_PER_PAGE - 1) {
      store.route.prescriptionFillsMailOrder.setValue('currentPage.prescriptionFills', currentPage + 1);
    }

    if (!store.route.prescriptionFillsMailOrder.activePrescriptionFillId) {
      const firstId = _get(store.route.prescriptionFills, 'mailOrderedByDate[0].data[0].id');
      store.route.prescriptionFillsMailOrder.setValue('activePrescriptionFillId', firstId);
    }
  })
  .catch(() => store.history.push(`${ROUTES.PRESCRIPTION_FILLS.VALUE}${ROUTES.PRESCRIPTION_FILLS.SUB_ROUTE.MAIL_ORDERED.VALUE}`))
  .finally(() => store.route.prescriptionFillsMailOrder.decrementHttp('listingMailOrderedPrescriptionFills'));
};
